import IdContext, { defaultContext } from './IdContext';
export default IdContext;
export { defaultContext };